"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _actionTypes = require("./actionTypes");

/**
 * Action creator to switch the `initMode` this module operates in.
 * @param {string} initMode The new `initMode`. Should be either `initMode.MODE_PREPARE` or
 * `initMode.MODE_INIT_SELF`
 * @returns {object} A Redux action object
 */
var _default = function _default(initMode) {
  return {
    type: _actionTypes.SET_INIT_MODE,
    payload: initMode
  };
};

exports.default = _default;